import React from "react";
//import zxcvbn from 'zxcvbn';
import validator from 'validator';
import { mainDiv, row, borderLine } from "./styles"; //
import { Link } from "react-router-dom";
import { screenSizeWithOutMenus, paddingForInputs } from '../multiFunctions.js';
import { Button, TextField } from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useState } from 'react';
import {
  faFacebookF,
  faGoogle,
  faApple,
} from "@fortawesome/free-brands-svg-icons";
import { login } from './functions.js';

function LoginDesktop() {
  const [ ErrorEmail, setErrorEmail] = useState('');
  
  const [ inputPassword, setInputPassword] = useState('');
  const [ inputEmail, setInputEmail ] = useState('');


  let mainDivStyle = {
    height: screenSizeWithOutMenus,
    display: "flex", 
    justifyContent: "center",
    backgroundImage: "url(./img/backgroundSite.png)",
    backgroundRepeat: "repeat",
  }
  const handleInputChange = (event) => {
    const name = event && event.target && event.target.id;
    const value = event && event.target && event.target.value;
    if (name && value) {
      switch(name) {
        case "password":
          setInputPassword(value);
          //setErrorPassword("");
          break;
        case "email":
          setInputEmail(value);
          setErrorEmail("");
          break;
        default:
          break;
      }
    }
  }

  const handleSubmit = function (event) {
  let loginObj = {
    email: inputEmail,
    password: inputPassword
  }

  let isValidEmail = validatorInput('email', loginObj);
   
  if (isValidEmail) {
    login(loginObj);
  }
   
  };

  const validatorInput = function(typeIn, objIn) {
    let isValid = true;
    //let result = null;
    switch(typeIn) {
        case "email":
                if (!validator.isEmail(objIn.email)) {
                    setErrorEmail('Error please add a valid email');
                    isValid = false;
                } else {
                    setErrorEmail("");
                }
            break;
        case "password":
                if (objIn.password.length > 6) {
                  /*result = zxcvbn(objIn.password);
                  if (result.score <= 3) {
                    if (result && result.feedback && result.feedback.suggestions.join(" ")) {
                      setErrorPassword(result.feedback.suggestions.join(" "));
                      isValid = false;
                    }
                  }*/
                } else {
                  //setErrorPassword("Your password should be at least 6 chars long");
                  isValid = false;
                }
            break;
        default:
            break;

    }
    return isValid;
  }

  return (
    <div style={mainDivStyle}>
      <div style={{ ...mainDiv }}>
          <div style={{ display: "flex", justifyContent: "center", alignContent: "center", height: "460px", width: "100%" }}>
            
              <div
                style={{
                  paddingTop: "15px",                
                  backgroundColor: "white",
                  borderRadius: "30px 0px 0px 30px",
                  padding: "40px"
                }}>
                <div style={{ fontSize: "xx-large", paddingTop: "15px" }} >
                  Login
                </div>
                <div
                  style={{
                    ...row,
                    fontSize: "x-large",
                    paddingTop: "15px",
                    justifyContent: "flex-start",
                    textAlign: "left"
                  }} >
                  Email
                </div>
                <div style={{ paddingTop: "15px" }}>
                  <TextField
                    id="email"
                    variant="standard"
                    label=""
                    fullWidth
                    style={borderLine}
                    onChange={handleInputChange}
                    error={!!ErrorEmail}
                    helperText={ErrorEmail}
                    sx={{ '& .MuiFormHelperText-root': { ...paddingForInputs, color: "red", fontWeight: "700", position: "relative", top: "20px"  } }}
                    InputProps={{
                      disableUnderline: true,
                      style: {
                        border: "none",
                        outline: "none",
                        backgroundColor: "transparent",
                        ...paddingForInputs
                      },
                    }}
                  />
                </div>
                <div
                  style={{
                    fontSize: "x-large",
                    paddingTop: "15px",
                    justifyContent: "flex-start",
                    textAlign: "left"
                  }} >
                  Password
                </div>

                <div style={{ paddingTop: "15px" }}>
                  <TextField
                    id="password"
                    variant="standard"
                    label=""
                    fullWidth
                    type="password"
                    style={borderLine}
                    onChange={handleInputChange}                    
                    sx={{ '& .MuiFormHelperText-root': { ...paddingForInputs, color: "red", fontWeight: "700", position: "relative", top: "20px" } }}
                    InputProps={{
                      disableUnderline: true,
                      style: {
                        border: "none",
                        outline: "none",
                        backgroundColor: "transparent",
                        ...paddingForInputs
                      },
                    }}
                  />
                </div>
                <div style={{ fontSize: "medium", paddingTop: "15px" }}>
                  Forgot your password?
                </div>
                <div
                  style={{ fontSize: "x-large", paddingTop: "15px", display: "flex", justifyContent: "center" }} >
                  <Button
                    onClick={handleSubmit}
                    type="submit"
                    variant="contained"
                    sx={{
                      borderRadius: "30px",
                      backgroundColor: "white",
                      color: "black",
                      width: "150px"
                    }} >
                    Login
                  </Button>
                </div>
                <div style={{ paddingTop: "15px", fontSize: "x-large", padding: "10px", display: "none", justifyContent: "center" }}>
                  <div style={{ paddingRight: "10px" }}>
                    <FontAwesomeIcon icon={faFacebookF} />
                  </div>
                  <div style={{ paddingRight: "10px" }}>
                    <FontAwesomeIcon icon={faGoogle} />
                  </div>
                  <div>
                    <FontAwesomeIcon icon={faApple} />
                  </div>
                </div>
                
            </div>
            <DivRight/>
          </div>
      </div>
    </div>
    )
}

function DivRight() {
  return (
    <>
      <div
        style={{
          paddingTop: "10px",
          backgroundColor: "#8fa464",
          color: "white",
          alignItems: "center",
          width: "40%",
          display: "flex", justifyContent: "center", flexFlow: "column", borderRadius: "0px 30px 30px 0px"
        }} >
        <div style={{ fontSize: "xx-large", textAlign: "center" }} >
          <span>You don&apos;t</span>
          <span> have an account?</span>
        </div>
        <div style={{ paddingTop: "10px" }}>
          <Link
            to="/register"
            style={{ color: "white", textDecoration: "underline" }} >
            Click here
          </Link>
        </div>
        <div style={{ paddingTop: "10px" }}></div>
        <div
          style={{
            fontSize: "medium",
            paddingTop: "15px",
            paddingBottom: "15px",
          }}>
          Use your email to log in
        </div>
      </div>
      </>
  )

}

export default LoginDesktop;